import { FC, useState } from 'react';
import { ManagedCommItem } from '../../../../../../hooks/use-communications/types/managed-communication';
import { TemplateViewerDialog } from '../../../../../shared/template/template-viewer/template-viewer-dialog';
import { ManagedCommCardTitle } from '../shared/title/managed-comm-card-title';
import { ManagedCommCard, ManagedCommCardWrapper, ManagedCommSignature } from '../styles';

interface MailMangedCommCardProps {
  communication: ManagedCommItem;
}

export const MailMangedCommCard: FC<MailMangedCommCardProps> = (props) => {
  const { communication } = props;
  const [viewTemplateDialogOpen, setViewTemplateDialogOpen] = useState(false);

  const handleCardClick = async () => {
    setViewTemplateDialogOpen(true);
  };

  return (
    <ManagedCommCardWrapper>
      <ManagedCommCard>
        <ManagedCommCardTitle communication={communication} onClickOnly={handleCardClick} />
      </ManagedCommCard>
      <ManagedCommSignature communication={communication} />
      {viewTemplateDialogOpen && communication.communicationId && (
        <TemplateViewerDialog
          open={viewTemplateDialogOpen}
          communicationId={communication.communicationId}
          title={'Mail'}
          subject={communication.subject}
          to={communication.sentTo}
          date={communication.date}
          onClose={() => setViewTemplateDialogOpen(false)}
        />
      )}
    </ManagedCommCardWrapper>
  );
};
